<div class="p-grid" *ngIf="loading">
  <div>
    <span class="counter-title">Tasks</span>
  </div>
  <div [@balloonEffect]=currentState>
    <span class="counter overdue" (click)="navigateToTask()" title="Overdue">
      {{counters?.OverDue}}
    </span>
  </div>
  <div [@balloonEffect]=currentState>
    <span class="counter warning" (click)="navigateToTask()" title="Warning">
      {{counters?.Warning}}
    </span>
  </div>
  <div [@balloonEffect]=currentState>
    <span class="counter ontime" (click)="navigateToTask()" title="On Time">
      {{counters?.OnTime}}
    </span>
  </div>
  <div [@balloonEffect]=currentState>
    <span class="counter complete" (click)="navigateToTask()" title="Completed">
      {{counters?.Completed}}
    </span>
  </div>
</div>
